import { validateQueryStringParameters } from "../../helpers/api";
import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const analysisCodeApi = tokenSlice.injectEndpoints({
    reducerPath: 'analysisCode',
    baseQuery: createBaseQuery(),
    tagTypes: ['AnalysisCode'],
    endpoints(builder) {
        return {

            // GET

            getAnalysisCode: builder.query({
                query: (params) => {
                    return {
                        url: `AnalysisCode/AnalysisCodes`,
                        params: validateQueryStringParameters(params)
                    }
                },
                providesTags: ['AnalysisCode'],
            }),

            getAnalysisById: builder.query({
                query: (dimensionId) => {
                    return {
                        url: `AnalysisCode/AnalysisCodes/${dimensionId}`,
                        method: 'GET'
                    }
                },
                providesTags: ['AnalysisCode'],
            }),

            getByDimension: builder.query({
                query: (id) => {
                    return {
                        url: `AnalysisCode/ByDimension/${id}`,
                        method: 'GET'
                    }
                },
                providesTags: ['AnalysisCode'],
            }),

            getByBusinessUnit: builder.query({
                query: (id) => {
                    return {
                        url: `AnalysisCode/ByBusinessUnit/${id}`,
                        method: 'GET'
                    }
                },
                providesTags: ['AnalysisCode'],
            }),

            // POST

            postAnalysisCodeSave: builder.mutation({
                query: (data) => ({
                    url: 'AnalysisCode/Save',
                    method: 'POST',
                    body: data
                }),
                invalidatesTags: ['AnalysisCode'],
            }),

            postPrequalifications: builder.mutation({
                query: (args) => {
                  const { id, vendorId, url } = args;
                //   const mainUrl = `/SupplierEvaluation/Prequalification`;
                //   const url = vendorId ? `${mainUrl}?ids=${id}&vendorId=${vendorId}` : `${mainUrl}?ids=${id}`;
                  
                  return {
                    method: 'post',
                    url: url,
                  };
                },
                invalidatesTags: ['AnalysisCode'],
            }),
              

            // DELETE

            deleteAnalysisCodeDelete: builder.mutation({
                query: (data) => ({
                    url: 'AnalysisCode/Delete',
                    method: 'DELETE',
                    body: data
                }),
                invalidatesTags: ['AnalysisCode']
            }),


            // getPrequalifications: builder.query({
            //     query: (args) => {
            //         const { id, vendorId } = args;
            //         const mainUrl = `/SupplierEvaluation/Prequalification?ids=${id}`
            //         return {
            //             url: vendorId ? `${mainUrl}?vendorId=${vendorId}` : mainUrl,
            //         }
            //     },
            //     providesTags: ['AnalysisCode'],
            // }),
        }
    }
})

export const { useGetAnalysisByIdQuery,
    useGetByBusinessUnitQuery, usePostAnalysisCodeSaveMutation,
    useGetByDimensionQuery, useDeleteAnalysisCodeDeleteMutation,
    useGetAnalysisCodeQuery, usePostPrequalificationsMutation } = analysisCodeApi;
export { analysisCodeApi };